module.exports = __webpack_public_path__ + "static/media/qrIcon.9eaab25d.svg";